import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blueyonderDistance'
})
export class BlueyonderDistancePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value
      ? `${value} km`
      : 'Unknown';
  }

}
